module.exports = {
          srcSet: __webpack_public_path__ + "f7a234d74b2fed2a2580d2720d36900c-36.png"+" 36w",
          images:[ {path: __webpack_public_path__ + "f7a234d74b2fed2a2580d2720d36900c-36.png",width: 36,height: 40}],
          src: __webpack_public_path__ + "f7a234d74b2fed2a2580d2720d36900c-36.png",
          toString:function(){return __webpack_public_path__ + "f7a234d74b2fed2a2580d2720d36900c-36.png"},
          
          width: 36,
          height: 40
        }